import * as type from '../../../actions/index.types';

export function CtrlBrandReducers(
    state = {
        loading: false,
        createLoading: false,
        detailsLoading: false,
        brandData: null,
        brandDetails: null,
        error: null,
    },
    action
) {
    switch (action.type) {

        /* =========================
           GET COMMUNITY LIST
        ========================= */
        case type.CTRL_BRAND_LIST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case type.CTRL_BRAND_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                brandData: action.payload,
            };

        case type.CTRL_BRAND_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action?.message || 'Something went wrong.',
            };

        /* =========================
           GET COMMUNITY DETAILS
        ========================= */
        case type.CTRL_GET_BRAND:
            return {
                ...state,
                detailsLoading: true,
                error: null,
            };

        case type.CTRL_GET_BRAND_SUCCESS:
            return {
                ...state,
                detailsLoading: false,
                error: null,
                brandDetails: action.payload,
            };

        case type.CTRL_GET_BRAND_FAILURE:
            return {
                ...state,
                detailsLoading: false,
                error: action?.message || 'Something went wrong.',
            };

        /* =========================
           CREATE COMMUNITY
        ========================= */
        case type.CTRL_CREATE_BRAND:
            return {
                ...state,
                createLoading: true,
                error: null,
            };

        case type.CTRL_CREATE_BRAND_SUCCESS:
            return {
                ...state,
                createLoading: false,
                error: null,
            };

        case type.CTRL_CREATE_BRAND_FAILURE:
            return {
                ...state,
                createLoading: false,
                error: action?.message || 'Something went wrong.',
            };

        /* =========================
           EDIT COMMUNITY
        ========================= */
        case type.CTRL_EDIT_BRAND:
            return {
                ...state,
                createLoading: true,
                error: null,
            };

        case type.CTRL_EDIT_BRAND_SUCCESS:
            return {
                ...state,
                createLoading: false,
                error: null,
                communityDetails: action.payload,
            };

        case type.CTRL_EDIT_BRAND_FAILURE:
            return {
                ...state,
                createLoading: false,
                error: action?.message || 'Something went wrong.',
            };

        /* =========================
           DELETE COMMUNITY
        ========================= */
        case type.CTRL_DELETE_BRAND:
            return {
                ...state,
                detailsLoading: true,
                error: null,
            };

        case type.CTRL_DELETE_BRAND_SUCCESS:
            return {
                ...state,
                detailsLoading: false,
                error: null,
            };

        case type.CTRL_DELETE_BRAND_FAILURE:
            return {
                ...state,
                detailsLoading: false,
                error: action?.message || 'Something went wrong.',
            };

        default:
            return state;
    }
}
